var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "my-bookmark__item" }, [
    _c(
      "a",
      {
        staticClass: "my-bookmark__item__link #bookmark_list",
        attrs: { href: _vm.post.permLink }
      },
      [
        _c("strong", { staticClass: "my-bookmark__item__title" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "my-bookmark__item__detail" }, [
          _c("span", { staticClass: "my-bookmark__item__detail__item" }, [
            _c("span", { staticClass: "sr_only" }, [_vm._v("작성자: ")]),
            _vm._v(_vm._s(_vm.post.creatorName))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "my-bookmark__item__detail__item" }, [
            _c("span", { staticClass: "sr_only" }, [_vm._v("작성일: ")]),
            _vm._v(_vm._s(_vm.created))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "my-bookmark__item__detail__item" }, [
            _c("span", { staticClass: "sr_only" }, [_vm._v("게시된 카페: ")]),
            _vm._v(_vm._s(_vm.post.cafeName))
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "my-bookmark__item__action",
        on: {
          click: function($event) {
            return _vm.deleteBookmark()
          }
        }
      },
      [_vm._m(0)]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "ico-delete" }, [
      _c("span", { staticClass: "sr_only" }, [_vm._v("북마크 삭제")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }